import React from 'react';
import styled from 'styled-components';
import GooglePlacesAutocomplete, {
  getLatLng,
  geocodeByAddress,
} from 'react-google-places-autocomplete';
import 'react-google-places-autocomplete/dist/index.min.css';
import { useDispatch, useSelector } from 'react-redux';

import { QUARTER_CONTRAST } from '../../theme';

const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
`;

const Subunits = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 12px;
`;

const Subunit = styled.div`
  padding: 8px;
  cursor: pointer;
`;

const inputTheme = {
  borderWidth: 1,
  borderRadius: 3,
  borderColor: QUARTER_CONTRAST,
  width: 'calc(100% - 16px)',
  fontSize: 16,
  padding: 12,
  marginBottom: 8,
  boxSizing: 'border-box',
  fontFamily: 'Montserrat, Open Sans, sans-serif',
};

export const GooglePlacesSearch = () => {
  const dispatch = useDispatch();
  const subunits = useSelector((state) => state.subunits);
  const reports = useSelector((state) => state.reports);

  const selectOne = async (result) => {
    const geocode = await geocodeByAddress(result.description);
    const lngLat = await getLatLng(geocode[0]);
    const action = {
      type: 'SET_MAP_SETTINGS',
      payload: {
        id: 'MAIN_MAP',
        settings: {
          center: lngLat,
          zoom: 14,
        },
      },
    };

    dispatch({
      type: 'OPEN_SIDE_PANEL',
      payload: {
        type: 'PARCEL',
        data: {
          config: {
            lngLat,
            report: reports.find(({ id }) => id === 'PARCEL_REPORT'),
          },
        },
      },
    });

    dispatch(action);
  };

  return (
    <SearchContainer>
      <GooglePlacesAutocomplete
        placeholder="Find an address..."
        inputStyle={inputTheme}
        onSelect={selectOne}
        suggestionsStyles={{
          suggestion: {
            padding: 6,
            borderBottomWidth: 1,
            borderBottomColor: QUARTER_CONTRAST,
            borderBottomStyle: 'solid',
            marginRight: 16,
          },
        }}
      />
      {!subunits.length ? null : (
        <Subunits>
          <Subunit>
            <strong>Subunits</strong>
          </Subunit>
          {subunits.map(({ settings, name }) => (
            <Subunit
              key={name}
              onClick={() => {
                const action = {
                  type: 'SET_MAP_SETTINGS',
                  payload: {
                    id: 'MAIN_MAP',
                    settings,
                  },
                };
                dispatch(action);
              }}
            >
              {name}
            </Subunit>
          ))}
        </Subunits>
      )}
    </SearchContainer>
  );
};
